<template>
    <el-dialog title="新增急救司机" :append-to-body="true" :visible.sync="showTag" width="30%">
        <el-form :model="form" label-width="100px" size="mini">
            <el-form-item label="姓名">
                <el-input v-model="form.staffName"></el-input>
            </el-form-item>
            <el-form-item label="手机号">
                <el-input v-model="form.userMobile"></el-input>
            </el-form-item>
            <el-form-item label="身份证">
                <el-input v-model="form.staffIdcard"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button @click="showTag = false" size="mini">取 消</el-button>
            <el-button type="primary" @click="sub" size="mini">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
  import {staffService} from "../service/staff";
  import {isEmpty} from "../../../common/lib/utils";
  import {STAFF_ADD_DRIVER_FIELDS} from "../config";
  import {STAFF_ADD_DRIVER_SUCCESS} from "../events";

  export default {
    name: "add-driver-dialog",
    data() {
      let form = {};
      STAFF_ADD_DRIVER_FIELDS.forEach(r => {
        form[r] = '';
      })
      return {
        showTag: false,
        form
      }
    },
    methods: {
      show(data) {
        this.showTag = true;
        if (!isEmpty(data)) {
          STAFF_ADD_DRIVER_FIELDS.forEach(r => {
            data[r] && this.$set(this.form, r, data[r]);
          });
        }
      },
      hide() {
        this.showTag = false;
      },
      async sub() {
        if (this.form.id) {
          if (await staffService.modifyDriver(this.form)) {
            this.hide();
            this.$message.success({
              message: '修改成功',
              onClose: () => {
                bus.$emit(STAFF_ADD_DRIVER_SUCCESS.id, 0)
              }
            })
          }
          return;
        }
        if (await staffService.addDriver(this.form)) {
          this.hide();
          this.$message.success({
            message: '增加成功',
            onClose: () => {
              bus.$emit(STAFF_ADD_DRIVER_SUCCESS.id, 0)
            }
          })
        }
      }
    },
  }
</script>

<style scoped>
</style>
